<template>
	<div>
		<slot>Set content as inline template.</slot>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				audioList: [],
				selected: null
			}
		},
		mounted() {
			axios.get(this.route('api.audio')).then(response => {
				this.audioList = response.data;
				// this.select(0);
			});
		},
		methods: {
			select(index) {
				this.selected = index;
				this.$root.$emit('select', this.audioList[this.selected]);
			}
		}
	}

</script>



// WEBPACK FOOTER //
// resources/assets/js/components/AudioLibrary.vue